import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ReportingCountry from '../Components/ChapterTwo/ReportingCountry';
import CountryOfOrigin from '../Components/ChapterTwo/CountryOfOrigin';
import classes from '../Style/ChapterTwo.scss';
import { useState } from 'react';
import { CircularProgress, useMediaQuery } from '@mui/material';


function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`
	};
}

const ChapterTwo = () => {
	const screenWidht = useMediaQuery('(max-width:1550px)')
	const screenWidhtSmall = useMediaQuery('(max-width:1290px)')
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const [animationStateFirst, setAnimationStateFirst] = useState(false);
	const [animationStateSecond, setAnimationStateSecond] = useState(false);

	return (
		<Box sx={{ width: '100%',display:'flex',flexDirection:'column', alignItems:'center' }}>
			<Box   sx={{ border: 1, backgroundColor:'#F5F5F5', borderColor:'#E5E5E5', borderWidth:'2px', borderBottomColor: '#22294D', minWidth:{xs:'180px',lg:screenWidhtSmall?'1000px':screenWidht?"1000px":"1400px"},paddingLeft:"22px",marginTop:"20px", }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='basic tabs example'
					variant='standart'
					TabIndicatorProps={{
						style: { background: '#38B292', height: '7px' }
					}}
				>
					<Tab
						onAnimationStart={() => {
							// console.log('started');
							setAnimationStateFirst(true);
							setAnimationStateSecond(false);
							setTimeout(() => {
								setAnimationStateFirst(false);
							}, 1000);
						}}
						onAnimationEndCapture={() => {
							// console.log('ended');
							setTimeout(() => {
								setAnimationStateFirst(false);
								setAnimationStateSecond(false);
							}, 200);
						}}
						sx={{
							backgroundColor: 'transparent',
							color: '#22294D !important',
							fontWeight: 'bold'
						}}
						className={value === 0 ? 'selected-tab-1' : 'unselected'}
						label='REPORTING COUNTRY'
						{...a11yProps(0)}
					/>
					<Tab
						onAnimationStart={() => {
							setAnimationStateSecond(true);
							setAnimationStateFirst(false);
							setTimeout(() => {
								setAnimationStateSecond(false);
							}, 1000);
						}}
						onAnimationEnd={() => {
							// console.log('ended');
							setTimeout(() => {
								setAnimationStateSecond(false);
								setAnimationStateFirst(false);
							}, 200);
						}}
						sx={{
							backgroundColor: 'transparent',
							color: '#22294D !important',
							fontWeight: 'bold'
						}}
						className={value === 1 ? 'selected-tab-2' : 'unselected'}
						label='COUNTRY OF ORIGIN'
						{...a11yProps(1)}
					/>
				</Tabs>
			</Box>
			<TabPanel value={value} index={0}>
				{!animationStateFirst && <ReportingCountry />}
				{animationStateFirst && (
					<Box sx={{ display: 'flex', justifyContent: 'center' }}>
						<CircularProgress />
					</Box>
				)}
			</TabPanel>
			<TabPanel value={value} index={1}>
				{!animationStateSecond && <CountryOfOrigin />}
				{animationStateSecond && (
					<Box sx={{ display: 'flex', justifyContent: 'center' }}>
						<CircularProgress />
					</Box>
				)}
			</TabPanel>
		</Box>
	);
};

export default ChapterTwo;
